import React from 'react';
import styled from '@emotion/styled';
import { MdMenu } from 'react-icons/md';
import { css } from '@emotion/core';
import { size } from 'polished';
import { Z_TOP } from '../util/zIndex';

const StyledButton = styled.button({
  color: 'inherit',
  width: `30px`,
  height: `40px`,
  border: 0,
  background: 'none',
  outline: 'none',
  cursor: 'pointer',
  zIndex: Z_TOP,
  svg: css(size(24), {
    display: 'block',
    fill: 'currentColor'
  })
});

export default function MenuButton({ onClick }) {
  return (
    <StyledButton onClick={onClick} aria-label="Navigation">
      <MdMenu />
    </StyledButton>
  );
}
